import _ from 'lodash';
import { useRouter } from 'next/compat/router';
import { useApolloClient } from '@apollo/client';

import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_DEFAULT_MESSAGES, ERNIE_TIMEOUTS, ERNIE_TYPES } from 'shared/constants';
import { consumerLoginV2 } from 'src/state/actions/users';
import useTranslation from 'hooks/use-translation';
import useUser from 'hooks/use-user';
import { StatusTypes } from 'src/gql/graphql';

type UseLoginResult = {
  login: ({ password, turnstileToken }: { password: string; turnstileToken: string }) => Promise<void>;
};

export const useLogin = (): UseLoginResult => {
  const { t } = useTranslation();
  const apolloClient = useApolloClient();
  const User = useUser();
  const router = useRouter();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const showErnie = useErnie();

  const text = {
    failedLogin: t('login.fail', '{{message}}', { message: ERNIE_DEFAULT_MESSAGES.LOGIN }),
  };

  const login = async ({ password, turnstileToken }): Promise<void> => {
    try {
      const result = await consumerLoginV2({
        apolloClient,
        User,
        email: DutchiePayEnrollment.userEmail,
        password,
        turnstileToken,
        dispensaryId: DutchiePayEnrollment.dispensary?.id,
      });

      if (result.success) {
        if (User.payByBankEnrollmentStatus !== StatusTypes.statusEnrolled) {
          void router?.push({
            pathname: `/pay/signup`,
            query: { refUrl: `/pay/instore` },
          });
        }
      } else {
        const message = _.get(result, `error.graphQLErrors[0].extensions.errors[0].detail`, text.failedLogin);
        showErnie(message, ERNIE_TYPES.DANGER, ERNIE_TIMEOUTS.LONG);
      }
    } catch (err) {
      console.error(err);
      showErnie(err.message, ERNIE_TYPES.DANGER, ERNIE_TIMEOUTS.LONG);
    }
  };

  return {
    login,
  };
};
